import { IApiGateway } from '@/modules/api/api.interface'
import { EmailTemplatesScope } from '@/shared/domain/enums/email-templates-scope.enum'

import { IEmailTemplateRepository } from './email-template.repository.interface'
import { EmailTemplateByOrganizationResponse, EmailTemplateResponse } from './email-template.types'

export class EmailTemplateRepository implements IEmailTemplateRepository {
  constructor(private api: IApiGateway) {}

  async getById(id: string): Promise<EmailTemplateResponse> {
    return this.api.get<EmailTemplateResponse>(`/email-templates/${id}`)
  }

  async getByOrganization(
    organizationId: string,
    scope: EmailTemplatesScope,
  ): Promise<EmailTemplateByOrganizationResponse[]> {
    return this.api.get<EmailTemplateResponse[]>(`/email-templates/organization/${organizationId}`, {
      params: {
        scope,
      },
    })
  }
}
